import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeasonalLeaseRateCalculatorComponent } from './components';
import { CommonComponentsModule } from '@app/common-components/common-components.module';
import { FormsModule } from '@angular/forms';
import { DirectMailService } from './services/direct-mail.service';
import { ListingConfigurationService } from './services/listing-configuration.service';
import { CheckInOutGridComponent } from './components/check-in-out-grid/check-in-out-grid.component';
import { CheckinConfigComponent } from './components/checkin-config/checkin-config.component';
import { CheckInEventsComponent } from './components/check-in-events/check-in-events.component';
import { CheckInEventGridComponent } from './components/check-in-event-grid/check-in-event-grid.component';
import { LinkToNewAdminListingComponent } from './components/link-to-new-admin-listing/link-to-new-admin-listing.component';
import { RouterModule } from '@app/shared2-components';
import { SeasonalLeaseGridViewComponent } from './components/seasonal-lease-grid-view/seasonal-lease-grid-view.component';
import { SeasonLookupFormComponent } from './components/season-lookup-form/season-lookup-form.component';
import { SeasonLookupGridComponent } from './components/season-lookup-grid/season-lookup-grid.component';
import { AnnualLeaseGridComponent } from './components/annual-lease-grid/annual-lease-grid.component';
import { AnnualLeaseComponent } from './components/annual-lease/annual-lease.component';
import { SeasonLookupPickerComponent } from './components/season-lookup-picker/season-lookup-picker.component';
import { LeaseSeasonFormComponent } from './components/lease-season-form/lease-season-form.component';
import { LeaseSeasonGridComponent } from './components/lease-season-grid/lease-season-grid.component';
import { LandownerOnboardCodeEntryComponent } from './components/landowner-onboard-code-entry/landowner-onboard-code-entry.component';
import { OnboardWhyOAComponent } from './components/onboard-why-oa/onboard-why-oa.component';
import { OnboardFAQsComponent } from './components/onboard-faqs/onboard-faqs.component';
import { BenefitsBarComponent } from './components/benefits-bar/benefits-bar.component';


/**
 * Components and services that are shared between Landowner and Admin modules
 */
@NgModule({
    providers: [DirectMailService, ListingConfigurationService],
    imports: [CommonModule, CommonComponentsModule, FormsModule, RouterModule, SeasonalLeaseRateCalculatorComponent,
        CheckInOutGridComponent,
        CheckInOutGridComponent,
        CheckinConfigComponent,
        CheckInEventsComponent,
        CheckInEventGridComponent,
        LinkToNewAdminListingComponent,
        SeasonalLeaseGridViewComponent,
        SeasonLookupFormComponent,
        SeasonLookupGridComponent,
        AnnualLeaseGridComponent,
        AnnualLeaseComponent,
        SeasonLookupPickerComponent,
        LeaseSeasonFormComponent,
        LeaseSeasonGridComponent,
        LandownerOnboardCodeEntryComponent,
        OnboardWhyOAComponent,
        OnboardFAQsComponent,
        BenefitsBarComponent],
    exports: [
        SeasonalLeaseRateCalculatorComponent,
        OnboardWhyOAComponent,
        CheckInOutGridComponent,
        CheckinConfigComponent,
        CheckInEventsComponent,
        CheckInEventGridComponent,
        LinkToNewAdminListingComponent,
        SeasonalLeaseGridViewComponent,
        SeasonLookupFormComponent,
        AnnualLeaseGridComponent,
        AnnualLeaseComponent,
        LeaseSeasonFormComponent,
        LeaseSeasonGridComponent,
        LandownerOnboardCodeEntryComponent,
        OnboardWhyOAComponent,
        OnboardFAQsComponent,
        BenefitsBarComponent
    ]
})
export class LandownerAdminSharedModule {}
